import { createContext } from 'react'
import { createContextualCan } from '@casl/react'
import { useAbility as useCanAbility } from '@casl/react'

export const AbilityContext = createContext()
export const useAbility = () => useCanAbility(AbilityContext)

export default createContextualCan(AbilityContext.Consumer)
